import {ServerConfig} from '@/config/routers';

export const getEditorImageProxyUrl = (src: string) => {
    return `${ServerConfig.ku}/square/picproxy?url=${encodeURIComponent(src) || ''}`;
};
